(function () {
  if (customElements.get('ps-problem-solution')) return;

  var MQ_DESKTOP = '(min-width: 45em)';

  class PsProblemSolution extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._touched = false;
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('keydown', this._onKeydown.bind(this));

      // Startzustand haengt vom Breakpoint ab -> bei Wechsel neu anwenden,
      // solange der Besucher noch nichts selbst auf-/zugeklappt hat.
      this._mq = window.matchMedia(MQ_DESKTOP);
      this._onBreakpoint = function () {
        if (this._touched) return;
        this._applyDefaultOpen(this.activePanel());
      }.bind(this);
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onBreakpoint);
      else if (this._mq.addListener) this._mq.addListener(this._onBreakpoint);

      this._applyDefaultOpen(this.activePanel());
    }

    disconnectedCallback() {
      if (!this._mq || !this._onBreakpoint) return;
      if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._onBreakpoint);
      else if (this._mq.removeListener) this._mq.removeListener(this._onBreakpoint);
    }

    get singleOpen() { return this.dataset.singleOpen !== 'false'; }

    /* 'none' | 'first' | 'all' - je nach Breakpoint aus den Section-Settings. */
    get openMode() {
      const desktop = window.matchMedia(MQ_DESKTOP).matches;
      const mode = desktop ? this.dataset.openDesktop : this.dataset.openMobile;
      return (mode === 'all' || mode === 'none') ? mode : 'first';
    }

    tabs() { return Array.from(this.querySelectorAll('[data-pss-tab]')); }
    panels() { return Array.from(this.querySelectorAll('[data-pss-panel]')); }
    activePanel() { return this.panels().find(function (p) { return !p.hasAttribute('hidden'); }); }

    _onClick(event) {
      const tab = event.target.closest('[data-pss-tab]');
      if (tab && this.contains(tab)) { this.selectTab(tab.dataset.pssTab); return; }

      const cart = event.target.closest('[data-pss-cart]');
      if (cart && this.contains(cart)) {
        // Quick-Add des Themes: der globale Delegate auf document.body
        // uebernimmt (Modal bei mehreren Varianten, sonst direkt in den
        // Warenkorb). Nur durchlassen - NICHT stopPropagation, sonst
        // erreicht der Klick den Handler nie. Die Karte bleibt offen,
        // weil wir hier trotzdem zurueckspringen.
        if (cart.hasAttribute('data-quick-add')) {
          this.preselectVariant(cart);
          return;
        }

        // Fallback, wenn Quick-Add im Theme deaktiviert ist.
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(cart);
        return;
      }

      // "Mehr Details": normal navigieren, Karte NICHT zuklappen.
      const link = event.target.closest('[data-pss-link]');
      if (link && this.contains(link)) return;

      const card = event.target.closest('[data-pss-card]');
      if (!card || !this.contains(card)) return;

      // Startzustand "Alle Karten offen": die Karten sind reine Anzeige.
      // Ein Klick darf sie NICHT zuklappen - zur Produktseite geht es ueber
      // "Mehr Details", in den Warenkorb ueber den gruenen Button.
      if (this.openMode === 'all') return;

      this.toggleCard(card);
    }

    _onKeydown(event) {
      const tab = event.target.closest('[data-pss-tab]');
      if (!tab || !this.contains(tab)) return;
      const keys = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 1, ArrowUp: -1 };
      if (!(event.key in keys)) return;
      event.preventDefault();
      const tabs = this.tabs();
      const next = (tabs.indexOf(tab) + keys[event.key] + tabs.length) % tabs.length;
      tabs[next].focus();
      this.selectTab(tabs[next].dataset.pssTab);
    }

    selectTab(index) {
      this.tabs().forEach(function (t) {
        const on = t.dataset.pssTab === String(index);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      let target = null;
      this.panels().forEach(function (p) {
        const on = p.dataset.pssPanel === String(index);
        if (on) { p.removeAttribute('hidden'); target = p; } else { p.setAttribute('hidden', ''); }
      });
      this._applyDefaultOpen(target);
    }

    _applyDefaultOpen(panel) {
      if (!panel) return;
      const mode = this.openMode;
      const cards = Array.from(panel.querySelectorAll('[data-pss-card]'));
      cards.forEach(function (c, i) {
        const open = mode === 'all' || (mode === 'first' && i === 0);
        c.classList.toggle('is-open', open);
        const info = c.querySelector('[data-pss-info]');
        if (info) info.setAttribute('aria-expanded', open ? 'true' : 'false');
      }, this);
    }

    toggleCard(card) {
      this._touched = true;
      const willOpen = !card.classList.contains('is-open');
      // Bei Startzustand "Alle Karten offen" greift die Einzel-Regel nicht,
      // sonst wuerde der erste Klick alle uebrigen Karten zuklappen.
      if (willOpen && this.singleOpen && this.openMode !== 'all') {
        const panel = card.closest('[data-pss-panel]');
        if (panel) {
          panel.querySelectorAll('[data-pss-card].is-open').forEach(function (c) {
            c.classList.remove('is-open');
            const i = c.querySelector('[data-pss-info]');
            if (i) i.setAttribute('aria-expanded', 'false');
          });
        }
      }
      card.classList.toggle('is-open', willOpen);
      const info = card.querySelector('[data-pss-info]');
      if (info) info.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    /* --------------------------------------------------------------
       Quick-Add-Modal auf die gepinnte Variante stellen.

       theme.js holt das Modal ueber
       /products/<handle>?section_id=quick-add-product - ohne
       variant-Parameter. Es startet deshalb immer auf
       selected_or_first_available_variant, nicht auf der Variante,
       die die Kachel zeigt.

       Statt theme.js anzufassen setzen wir nach dem Oeffnen die
       Options-Selects auf die Werte der gepinnten Variante und feuern
       ein natives change - genau das macht das Theme intern auch,
       wenn jemand einen Options-Button klickt. Damit ziehen Preis,
       Grundpreis, SKU, Kaufen-Button und das versteckte
       name="id"-Select automatisch nach.
    -------------------------------------------------------------- */
    preselectVariant(button) {
      if (!button.hasAttribute('data-open-modal')) return;

      var handle = button.getAttribute('data-quick-add');
      var target = button.getAttribute('data-product-id');
      var values;
      try { values = JSON.parse(button.getAttribute('data-pss-options') || '[]'); }
      catch (err) { return; }
      if (!handle || !target || !values.length) return;

      var modal = document.querySelector('[data-quick-add-modal]');
      if (!modal) return;
      var content = modal.querySelector('.quick-add-modal__content') || modal;

      var pick = function () {
        var forms = content.querySelectorAll(
          'form[data-product-form][data-product-handle="' + handle + '"]'
        );
        return forms.length ? forms[forms.length - 1] : null;
      };

      // Beim Klick steht ggf. noch der Inhalt eines vorher geoeffneten
      // Produkts im Modal. Auf dieses Formular duerfen wir nicht losgehen,
      // es wird gleich ersetzt.
      var stale = pick();

      var tries = 0;
      var timer = null;
      var stop = function () {
        if (timer) clearInterval(timer);
        timer = null;
      };

      // Das Theme baut sein ProductForm erst nach einem eigenen
      // Produkt-Fetch. Wir wissen nicht, wann die Listener haengen, also
      // versuchen wir es im Takt, bis das versteckte name="id"-Select
      // wirklich auf der gewuenschten Variante steht.
      var attempt = function () {
        tries++;
        if (tries > 60) { stop(); return; }

        var form = pick();
        if (!form || form === stale) return;

        // Achtung: die Options-Selects stehen NICHT im <form>, sondern
        // daneben im Produktblock. Deshalb von dort aus suchen.
        var scope = form.closest('[data-quick-add-product]') || content;

        var selects = scope.querySelectorAll('select[name^="options"]');
        if (!selects.length) { stop(); return; }

        var idSelect = form.querySelector('select[name="id"]')
          || scope.querySelector('select[name="id"]');
        if (idSelect && idSelect.value === target) { stop(); return; }

        for (var i = 0; i < selects.length && i < values.length; i++) {
          var select = selects[i];
          var want = values[i];
          if (want == null) continue;

          var exists = false;
          for (var j = 0; j < select.options.length; j++) {
            if (select.options[j].value === want) { exists = true; break; }
          }
          if (!exists) continue;

          if (select.value !== want) select.value = want;
          select.dispatchEvent(new Event('change'));
        }

        if (idSelect && idSelect.value === target) stop();
      };

      timer = setInterval(attempt, 100);
      attempt();
    }

    addToCart(button) {
      const id = parseInt(button.dataset.variantId, 10);
      if (!id || button.classList.contains('is-loading')) return;

      const addUrl = (this.dataset.cartAddUrl || '/cart/add') + '.js';
      const cartUrl = this.dataset.cartUrl || '/cart';
      button.classList.add('is-loading');

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          button.classList.remove('is-loading');
          if (state && state.status && state.status !== 200) {
            console.warn('[ps-problem-solution] Add to cart failed:', state.description || state.message);
            return;
          }
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1800);

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            drawer.renderContents(state);
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.renderContents ? drawer.renderContents(state) : drawer.open();
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function (err) {
          button.classList.remove('is-loading');
          console.error('[ps-problem-solution]', err);
        });
    }
  }

  customElements.define('ps-problem-solution', PsProblemSolution);
})();
